import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"

export const Section = styled(SectionWrapper)`
  background-color: ${({ theme }) => theme.palette.secondary.light};
  /* overflow: hidden; */
  position: relative;
  padding: 0;
`

export const Wrapper = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;

  /* z-index: 2; */
  /* position: relative; */
`

export const BackgroundImage = styled(CustomBgImage)`
  padding-top: ${({ theme }) => theme.typography.pxToRem(220)};
  padding-bottom: ${({ theme }) => theme.typography.pxToRem(115)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding-top: ${({ theme }) => theme.typography.pxToRem(180)};
  }

  /* position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;

  img {
    object-fit: cover !important;
    width: 100%;
    height: 100%;
  } */
`

export const GroupContainer = styled.div`
  width: 885px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const LetterImage = styled(CustomBgImage)`
  overflow: unset;
  img {
    object-position: top;
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    min-width: 885px;
    img {
      object-fit: contain !important;
    }
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    /* padding-left: 1rem;
    padding-right: 1rem; */
    /* img {
      height: 1500px;
      object-fit: cover !important;
    } */
  }

  /* ${({ theme }) => theme.breakpoints.down(470)} {
    img {
      height: 100%;
      object-fit: cover !important;
    }
  } */
`

export const Content = styled.div`
  padding-top: ${({ theme }) => theme.typography.pxToRem(66)};
  padding-left: 2rem;
  padding-right: 2rem;
  position: relative;
  /* position: absolute; */
  /* left: 250px; */
  /* z-index: 3; */
  max-width: 725px;
  margin: auto;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(22)};
  font-style: normal;
  font-weight: 300;
  line-height: ${({ theme }) => theme.typography.pxToRem(32)};
  p {
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: ${({ theme }) => theme.typography.pxToRem(22)};
    font-style: normal;
    font-weight: 300;
    line-height: ${({ theme }) => theme.typography.pxToRem(32)};
  }
  #form {
    text-decoration: underline;
    cursor: pointer;
  }
  .gatsby-image-wrapper {
    margin: 0;
  }
  .item img {
    width: 18px;
  }
  .top img {
    width: 130px;
    margin: 0;
  }

  div {
    &.top {
      display: flex;
      column-gap: 1rem;
      align-items: center;

      .gatsby-image-wrapper {
        width: 130px;
        height: 36px;
        margin: 0;
        img {
          width: 130px;
          height: 34px;
        }
      }
      ${({ theme }) => theme.breakpoints.down("md")} {
        flex-direction: column;
        align-items: flex-start;
      }
    }
    &.list {
      padding-left: ${({ theme }) => theme.typography.pxToRem(50)};
      .gatsby-image-wrapper {
        width: 17px;
        height: 17px;
        img {
          width: 17px;
          height: 17px;
        }
      }
    }
    &.item {
      display: flex;
      align-items: center;
      column-gap: 0.8rem;
    }
    &.title {
      display: flex;
      column-gap: 0.5rem;
      margin-bottom: 1rem;
      align-items: center;
    }
    &.emoji {
      font-size: 3rem;
      ${({ theme }) => theme.breakpoints.down("md")} {
        font-size: 2rem;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(19)};
    line-height: ${({ theme }) => theme.typography.pxToRem(30)};
    padding: 1rem 1.5rem;

    p {
      font-size: ${({ theme }) => theme.typography.pxToRem(19)};
      line-height: ${({ theme }) => theme.typography.pxToRem(30)};
    }
  }
`

export const LetterIcon = styled(CustomImage)`
  position: absolute;
  bottom: -50px;
  right: 300px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    right: 100px;
  }
`
